var _rect, _rect2, _rect3, _rect4, _path, _circle, _rect5, _g, _rect6, _g2, _circle2, _circle3, _circle4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgNewLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 159,
    viewBox: "0 0 159 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 41,
    width: 105,
    height: 77,
    rx: 12,
    fill: "#FFC4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37.6676,
    y: 88.2401,
    width: 29.8188,
    height: 5.14117,
    rx: 2.57058,
    fill: "#FF9191"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37.6676,
    y: 76.9296,
    width: 48.327,
    height: 5.14117,
    rx: 2.57058,
    fill: "#FF9191"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 37.6676,
    y: 66.6472,
    width: 66.8352,
    height: 5.14117,
    rx: 2.57058,
    fill: "#FF9191"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 53C27 46.3726 32.3726 41 39 41H120C126.627 41 132 46.3726 132 53V57H27V53Z",
    fill: "url(#paint0_linear_1937_18809)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 126.808,
    cy: 93.0653,
    r: 18.1922,
    fill: "#FF6262"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1937_18809",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 82,
    width: 15,
    height: 15
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 131.763,
    y: 82.1721,
    width: 8.68188,
    height: 12.6876,
    rx: 4.34094,
    transform: "rotate(45 131.763 82.1721)",
    stroke: "black",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1937_18809)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.509 88.6711L133.179 79.3406L125.389 87.1299L134.72 96.4603L142.509 88.6711ZM134.72 96.4611L129.166 90.9072L125.154 94.9199L130.708 100.474L134.72 96.4611Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1937_18809",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 116,
    y: 89,
    width: 15,
    height: 15
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 122.321,
    y: 103.891,
    width: 8.68188,
    height: 12.6876,
    rx: 4.34094,
    transform: "rotate(-135 122.321 103.891)",
    stroke: "black",
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1937_18809)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.574 97.391L120.905 106.721L128.694 98.9322L119.364 89.6017L111.574 97.391ZM119.363 89.601L124.917 95.1548L128.93 91.1421L123.376 85.5883L119.363 89.601Z",
    fill: "white"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.7241,
    cy: 49.1673,
    r: 3.0847,
    fill: "#FF6262"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.9781,
    cy: 49.1673,
    r: 3.0847,
    fill: "#FF6262"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.2323,
    cy: 49.1673,
    r: 3.0847,
    fill: "#FF6262"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1937_18809",
    x1: 79.5,
    y1: 41,
    x2: 79.5,
    y2: 57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#FF9292"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgNewLink);
export default __webpack_public_path__ + "static/media/img_new_link.46acf7aac4574a80fc6c85799711f653.svg";
export { ForwardRef as ReactComponent };